import { initWba, sendEvent, WbaEvents } from "@js/shared/libs";
import { Store } from "@store/index";

const isFulfilled = <T>(
  result: PromiseSettledResult<T>,
): result is PromiseFulfilledResult<T> => result.status === "fulfilled";

class App {
  constructor() {
    this.init = this.init.bind(this);
  }

  async init() {
    const store = new Store();

    // window.addEventListener(EUserEvents.LOG_IN, () => {
    //   syncWbaClientId(store.entities.user.info?.sub);
    // });

    // window.addEventListener(EUserEvents.LOG_OUT, () => {
    //   syncWbaClientId("0");
    // });

    try {
      const componentLoaders = [
        // () => import("@components/auth"),
        () => import("@components/application"),
        () => import("@components/marquee"),
        () => import("@components/player"),
        // () => import("@components/guide"),
        () => import("@components/nominations"),
        () => import("@components/faq"),
        () => import("@components/agreemet"),
      ];

      const componentLoadResults = await Promise.allSettled(
        componentLoaders.map((loader) => loader()),
      );

      const loadedComponents = componentLoadResults
        .filter(isFulfilled)
        .map((result) => new result.value.default());

      const componentInitResults = await Promise.allSettled(
        loadedComponents.map((component) => Promise.resolve(component.init(store))),
      );

      componentLoadResults.forEach((result, index) => {
        if (result.status === "rejected") {
          console.error(`Failed to load component #${index + 1}`, result.reason);
        }
      });

      componentInitResults.forEach((result, index) => {
        if (result.status === "rejected") {
          console.error(`Failed to init component #${index + 1}`, result.reason);
        }
      });
    } catch (error) {
      console.error("Unexpected error during app initialization", error);
    }

    try {
      await store.init();
    } catch (error) {
      console.error("Unexpected error during store initialization", error);
    }

    if (window.location.hash !== "") {
      setTimeout(() => {
        const anchorElement = document.querySelector(window.location.hash);

        if (anchorElement !== null) {
          anchorElement.scrollIntoView({ block: "start", behavior: "instant" });
        }
      }, 0);
    }

    initWba();
    sendEvent(WbaEvents.PAGEVIEW);
  }
}

export { App };
